export default "__VITE_ASSET__C70YG5sv__"